import { lazy } from "react";
import Loadable from "app/components/Loadable";
import { authRoles } from "app/auth/authRoles";
import { Navigate } from "react-router-dom";

const Undertime = Loadable(lazy(() => import("./Undertime")));
const Overtimes = Loadable(lazy(() => import("./Overtime")));
const Leaves = Loadable(lazy(() => import("./Leave")));

const verifyRoutes = [
  {
    path: "/verify/leave",
    element: <Navigate to="/task/verify/leave" />,
    auth: authRoles.hr,
  },
  {
    path: "/verify/undertime",
    element: <Navigate to="/task/verify/undertime" />,
    auth: authRoles.hr,
  },
  {
    path: "/verify/overtime",
    element: <Navigate to="/task/verify/overtime" />,
    auth: authRoles.hr,
  },
  { path: "/task/verify/leave", element: <Leaves />, auth: authRoles.hr },
  {
    path: "/task/verify/undertime",
    element: <Undertime />,
    auth: authRoles.hr,
  },
  {
    path: "/task/verify/overtime",
    element: <Overtimes />,
    auth: authRoles.hr,
  },
];

export default verifyRoutes;
